import { render, staticRenderFns } from "./SalePricesAdditionalFees.vue?vue&type=template&id=a0fc5f10"
import script from "./SalePricesAdditionalFees.vue?vue&type=script&lang=js"
export * from "./SalePricesAdditionalFees.vue?vue&type=script&lang=js"
import style0 from "./SalePricesAdditionalFees.vue?vue&type=style&index=0&id=a0fc5f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports